import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { OidcClient } from "@axa-fr/oidc-client";
import { getConfigValue } from "@jutro/config";
import { joinUrl } from "@jutro/platform";
import { useAuthStorage } from "../storage/useAuthStorage";
import { AuthContext, AuthContextInternal } from "./AuthContext";
import { CONFIGURATION_NAME } from "./constants";
import { getOidcConfiguration } from "./getOidcConfiguration";
import { mergeParamsIfExists } from "./mergeParams";
import { OidcRoutes } from "./OidcRoutes";
import { OidcSession } from "./OidcSession";
var getTokens = function (oidc) {
    return null !== oidc.tokens ? {
      accessToken: oidc.tokens.accessToken,
      idToken: oidc.tokens.idToken
    } : null;
  },
  getIsAuthenticated = function (oidc, oidcUser) {
    return null !== oidc.tokens && null !== oidcUser;
  },
  getIsPending = function (oidc, oidcUser, isLoginPending, isLogoutPending) {
    return isLoginPending || isLogoutPending || null !== oidc.tokens && null === oidcUser;
  };
export var getBasePath = function () {
  var _context;
  return _sliceInstanceProperty(_context = new _URL(document.baseURI).pathname).call(_context, 1);
};
export var GenericAuthProvider = function (_ref) {
  var children = _ref.children,
    onLocationChange = _ref.onLocationChange,
    basePath = useMemo(function () {
      return getBasePath();
    }, []),
    oidc = useMemo(function () {
      return OidcClient.getOrCreate(function () {
        return fetch;
      })(getOidcConfiguration(basePath), CONFIGURATION_NAME);
    }, [basePath]),
    _useState = useState(!1),
    _useState2 = _slicedToArray(_useState, 2),
    isLoginPending = _useState2[0],
    setIsLoginPending = _useState2[1],
    _useState3 = useState(!1),
    _useState4 = _slicedToArray(_useState3, 2),
    isLogoutPending = _useState4[0],
    setIsLogoutPending = _useState4[1],
    _useState5 = useState(function () {
      return getTokens(oidc);
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    tokens = _useState6[0],
    setTokens = _useState6[1],
    _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    oidcUser = _useState8[0],
    setOidcUser = _useState8[1],
    _useState9 = useState(void 0),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  useEffect(function () {
    var hasChanged = !1,
      newSubscriptionId = oidc.subscribeEvents(function (name, data) {
        var _context2, _context3;
        hasChanged || (_includesInstanceProperty(_context2 = [OidcClient.eventNames.logout_from_another_tab, OidcClient.eventNames.logout_from_same_tab, OidcClient.eventNames.token_acquired, OidcClient.eventNames.token_renewed, OidcClient.eventNames.tryKeepExistingSessionAsync_end]).call(_context2, name) && setTokens(getTokens(oidc)), name === OidcClient.eventNames.refreshTokensAsync_error && oidc.loginAsync("", mergeParamsIfExists("JUTRO_AUTH_LOGIN_QUERY_EXTRAS", {})), _includesInstanceProperty(_context3 = [OidcClient.eventNames.loginAsync_error, OidcClient.eventNames.loginCallbackAsync_error, OidcClient.eventNames.silentLoginAsync_error, OidcClient.eventNames.syncTokensAsync_error, OidcClient.eventNames.tryKeepExistingSessionAsync_error]).call(_context3, name) && setError(new Error(name, {
          cause: _JSON$stringify(data)
        })));
      });
    return function () {
      hasChanged = !0, oidc.removeEventSubscription(newSubscriptionId);
    };
  }, [oidc]), useEffect(function () {
    var hasChanged = !1;
    return tokens || setOidcUser(null), tokens && oidc.userInfoAsync().then(function (info) {
      hasChanged || setOidcUser(info);
    }).catch(function (err) {
      hasChanged || (setOidcUser(null), setError(err));
    }), function () {
      hasChanged = !0;
    };
  }, [oidc, tokens]), useAuthStorage(tokens);
  var login = useCallback(function () {
      var callbackPath = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        extraParams = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return oidc.loginAsync(callbackPath, mergeParamsIfExists("JUTRO_AUTH_LOGIN_QUERY_EXTRAS", extraParams));
    }, [oidc]),
    logout = useCallback(function (fromPath, extraParams) {
      var defaultLogoutPath = joinUrl(basePath, getConfigValue("JUTRO_AUTH_LOGOUT_REDIRECT_PATH", "/logout")),
        logoutPath = null != fromPath ? fromPath : defaultLogoutPath;
      return setIsLogoutPending(!0), oidc.logoutAsync(logoutPath, mergeParamsIfExists("JUTRO_AUTH_LOGOUT_QUERY_EXTRAS", extraParams));
    }, [oidc, basePath]),
    contextValue = useMemo(function () {
      var _tokens$accessToken, _tokens$idToken;
      return {
        isAuthenticated: getIsAuthenticated(oidc, oidcUser),
        isPending: getIsPending(oidc, oidcUser, isLoginPending, isLogoutPending),
        accessToken: null !== (_tokens$accessToken = null == tokens ? void 0 : tokens.accessToken) && void 0 !== _tokens$accessToken ? _tokens$accessToken : null,
        idToken: null !== (_tokens$idToken = null == tokens ? void 0 : tokens.idToken) && void 0 !== _tokens$idToken ? _tokens$idToken : null,
        userInfo: oidcUser,
        error: error,
        login: login,
        logout: logout
      };
    }, [oidc, isLoginPending, isLogoutPending, tokens, oidcUser, error, login, logout]),
    internalContextValue = useMemo(function () {
      return {
        oidc: oidc,
        setIsLoginPending: setIsLoginPending,
        setError: setError,
        onLocationChange: onLocationChange
      };
    }, [oidc, onLocationChange]);
  return React.createElement(AuthContext.Provider, {
    value: contextValue
  }, React.createElement(AuthContextInternal.Provider, {
    value: internalContextValue
  }, React.createElement(OidcRoutes, null, React.createElement(OidcSession, null, children))));
};
GenericAuthProvider.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "GenericAuthProvider"
}, GenericAuthProvider.__docgenInfo = {
  componentName: "GenericAuthProvider",
  packageName: "@jutro/auth",
  description: "",
  displayName: "GenericAuthProvider",
  methods: [],
  actualName: "GenericAuthProvider"
};